export default __webpack_public_path__ + "static/media/jacobite-glenfinnan.cc26b4ae.webp";